import { NotFound } from '@illustrations';
import classNames from 'classnames';
import React from 'react';
import Typography from '../typography';
import { emptyClasses, EmptySC, prefixCls } from './empty.styled';

interface EmptyProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'title' | 'ref'
  > {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
}

const Empty: React.FunctionComponent<EmptyProps> = (props) => {
  const { className, title, description, children, ...rest } = props;

  return (
    <EmptySC className={classNames(prefixCls, className)} {...rest}>
      <NotFound width={100} height={100} className={emptyClasses.illustration} />
      {title ? <div className={emptyClasses.title}>{title}</div> : null}
      {description ? <div className={emptyClasses.description}>{description}</div> : null}
      {children ? <div className={emptyClasses.footer}>{children}</div> : null}
    </EmptySC>
  );
};

export default Empty;
